import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__set-dropdown-value';
export default class SetDropdownValue {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        $element.each((index, element) => {
            const $element = $(element);
            const $selectedOption = $element.find('option[selected]');
            const dropdownValue = $element.find('select').data('dropdown-value') || $selectedOption.prop('value');
            // @ts-ignore
            $element.dropdown('set selected', dropdownValue).trigger('change');
            $selectedOption.prop('disabled', false);
        });
    }
}
